@if (showAboutThisPage) {
  <div class="onboarding-page-overlay"></div>
}

<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Upsells'"
      [customBack]="'more'"
      [canGoBack]="!windowService.isDesktopRes"
      [showLinkIcon]="true"
      [linkIcon]="'add-circle'"
      (linkAction)="goToAddUpsellPage()" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper [hasBottomNav]="true" [isPrimaryLayer]="true">
    <ng-container *ngTemplateOutlet="topNav; context:{ extraClass: 'desktop' }" />

    @if (errorMessage) {
      <tidy-error-message
        [text]="errorMessage" />
    }

    @if (windowService?.isDesktopRes) {
      <tidy-desktop-header>
        <div class="wrappable-container">
          <tidy-text
            [title]="'Upsells'" />
          <form [formGroup]="form" novalidate action="#">
            <tidy-search-input
              formControlName="search"
              [placeholder]="'Search'"
              [icon]="'assets/img/search-header.svg'"
              class="header-search"
              [showClearButton]="true"
              (clear)="clearSearch()" />
          </form>
          <tidy-small-button
            [text]="'Upsell Settings'"
            [image]="'assets/img/settings-white.svg'"
            (buttonClick)="openUpsellSettings()" />
          <tidy-small-button
            [text]="'Integrate'"
            [image]="'assets/img/link-white.svg'"
            (buttonClick)="openIntegrationInfo()" />
          <tidy-small-button
            [text]="'Add Upsell'"
            [image]="'assets/img/add-button-white.svg'"
            (buttonClick)="goToAddUpsellPage()" />
          <tidy-image
            [src]="'assets/img/download_csv.svg'"
            class="desktop-header-icon secondary-text-icon"
            (action)="exportCSV()"/>
        </div>
        <div class="non-wrappable-right-aligned-container">
          @if (showLoadingSpinner) {
            <ion-spinner name="lines" class="header-loading-spinner" style="margin-right: 15px" />
          }
          <automations-preview-button
            [tag]="'upsells'" />
        </div>
      </tidy-desktop-header>
    }

    @if (!windowService?.isDesktopRes) {
      @if (rows?.length) {
        <form [formGroup]="form" novalidate action="#">
          <tidy-search-input
            formControlName="search"
            [placeholder]="'Search'"
            [icon]="'assets/img/search-header.svg'"
            class="header-search"
            [showClearButton]="true"
            (clear)="clearSearch()" />
        </form>
      }
    }

    <!-- Skeleton table while loading — rows float in with the entrance cascade;
         the real table below then replaces it in place, instantly (skipEntrance). -->
    @if (!loaded) {
      <tidy-table
        [skeletonLoading]="true"
        [columnslabels]="headers" />
    }

    @if (loaded) {
      <tidy-table
        #tidyTable
        [dataSource]="tableDataSource"
        [displayedColumns]="headers"
        [columnslabels]="headers"
        (sortChange)="sortChanged($event)"
        [showColumnLines]="false"
        [rowsToShow]="50"
        [allRowIsClickable]="true"
        (cellClick)="onTableColumnClick($event)"
        [infiniteScroll]="true"
        [totalRows]="filteredRows?.length > 0 ? filteredRows?.length : rows?.length"
        [skipEntrance]="true"
        (pageChange)="pageChange()" />
    }

  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [isfullWidthContent]="true" [templateContent]="content" [desktopWidthContent]="desktopWidthContent" />


@if (showAboutThisPage) {
  <tidy-about-this-page [page]="'upsells'" (dismissed)="dismissAboutThisPage()" />
}